<template>
  <div class="configurator">
    <v-form v-model="valid">
      <h2>{{ $t('configurator.dimensions.enter') }}</h2>
      <div class="configurator__label">{{ $t('configurator.dimensions.label') }}</div>
      <v-container>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-8">
            <v-text-field
              class="onex-form unit"
              v-model="cutOutWidth"
              :rules="[rules.required, rules.counter, rules.numeric]"
              :counter="10"
              :label="$t('configurator.dimensions.max_width_value')"
              required
            ></v-text-field>
            <v-text-field
              class="onex-form unit"
              v-model="cutOutHeight"
              :rules="[rules.required, rules.counter, rules.numeric]"
              :counter="10"
              :label="$t('configurator.dimensions.max_height_value')"
              required
            ></v-text-field>
          </div>
        </div>
      </v-container>
      <div class="configurator__label">{{ $t('configurator.colors.pick') }}</div>
      <v-container>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-8">
            <v-radio-group
                v-model="color"
                :rules="[rules.required]"
                @change="colorChange"
                required>
                <v-radio
                  :label="$t('configurator.colors.light_grey')"
                  color="black"
                  value="Light grey"
                  v-if="['view','tview'].includes($store.getters.coldroomSystem)"
                ></v-radio>
                <v-radio
                  :label="$t('configurator.colors.darkgrey')"
                  color="black"
                  value="Dark grey"
                  v-if="['view','tview'].includes($store.getters.coldroomSystem)"
                ></v-radio>
                <v-radio
                  :label="$t('configurator.colors.lightgrey')"
                  color="black"
                  value="Standard"
                  v-if="$store.getters.coldroomSystem == 'classic'"
                ></v-radio>
                <v-radio
                  :label="$t('configurator.colors.black')"
                  color="black"
                  value="Black"
                ></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-container>
      <div class="configurator__label u-display-none" aria-hidden="true" v-if="['view','tview'].includes($store.getters.coldroomSystem)">{{ $t('system.pick') }}</div>
      <v-container v-if="['view','tview'].includes($store.getters.coldroomSystem)">
        <div class="row u-display-none" aria-hidden="true">
          <div class="col-12 col-md-6 col-lg-8">
            <v-radio-group
                v-model="viewTView"
                readonly
                row>
              <v-radio
                  :label="$t('system.view.label')"
                  color="black"
                  value="view"
              ></v-radio>
              <v-radio
                  :label="$t('system.t_view.label')"
                  color="black"
                  value="tview"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-container>
      <div class="configurator__label">{{ $t('configurator.shelvings.label') }}</div>
      <v-container>
        <v-row>
          <v-col>
            <v-switch
              v-model="shelvingsSwitch"
              inset
              :label="$t('configurator.shelvings.add')"
              color="black"
              @change="shelvingsChange"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
      <button class="btn btn--secondary"
        @click="manualSetup()"
        :disabled="( !cutOutHeight || isNaN(cutOutHeight) || !color )"
      >
        {{ $t('configurator.manual_config') }}
      </button>
      <button class="btn btn--primary"
        @click="bestSetup()"
        :disabled="( !cutOutHeight || !cutOutWidth || isNaN(cutOutHeight) || isNaN(cutOutWidth) || !color )"
      >
        {{ $t('configurator.best_setup') }}
      </button>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
@import './../sass/main.scss';
h2 {
  @include media-breakpoint-up(md) {
    @include gutter(margin-top, xl);
  }
}
.btn {
  padding: $btn-padding-y;
  @include media-breakpoint-down(sm) {
    display: block;
    text-align: center;
  }
}
.btn--secondary {
  @include media-breakpoint-up(md) {
    margin-right: rem(12);
  }
}
</style>

<script>
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  data () {
    return {
      valid: false,
      rules: {
        required: value => !!value || "This field is required",
        counter: value => value.length <= 10 || "Maximum characters allowed is 10",
        numeric: value => Number.isInteger(parseInt(value)) || "Value must numeric"
      }
    }
  },
  mounted() {
    this.$store.commit("setShelvingsSwitch", false);
  },
  computed: {
    cutOutWidth: {
      get() {
        return this.$store.state.cutOutWidth;
      },
      set(value) {
        this.$store.commit("setCutOutWidth", value);
      },
    },
    cutOutHeight: {
      get() {
        return this.$store.state.cutOutHeight;
      },
      set(value) {
        this.$store.commit("setCutOutHeight", value);
      },
    },
    color: {
      get() {
        return this.$store.state.color;
      },
      set (value) {
        this.$store.commit("setColor", value);
      },
    },
    viewTView: {
      get() {
        return this.$store.state.coldroomSystem;
      },
      set(value) {
        this.$store.commit("setColdroomSystem", value)
      },
    },
    shelvingsSwitch: {
      get() {
        return this.$store.state.shelvingsSwitch;
      },
      set(value) {
        this.$store.commit("setShelvingsSwitch", value);
      },
    },
  },
  methods: {
    colorChange(element) {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.clickTracking('radio button', `color ${element.replace(/Standard/i, 'Light Gray')}`);
    },
    shelvingsChange(element) {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.clickTracking('checkbox', `shelvings ${element}`);
    },
    manualSetup () {
      this.saveAndStartConfigurator("/manual", 4);
    },
    bestSetup () {
      this.saveAndStartConfigurator("/system", 5)
    },
    saveAndStartConfigurator: function(route, goToStep) {
      this.$router.push({
        path: route,
        params: {
          step: goToStep
        }
      });
      var suggestedHeight;
      if (route == "/system") {
        if (this.$store.state.coldroomSystem == "classic") {
          if (this.$store.state.cutOutHeight < 1650) {
            suggestedHeight = 0;
          } else if (
            this.$store.state.cutOutHeight >= 1650 &&
            this.$store.state.cutOutHeight < 1850
          ) {
            suggestedHeight = 1644;
          } else if (this.$store.state.cutOutHeight >= 1850) {
            suggestedHeight = 1844;
          }
        } else {
          if (this.$store.state.cutOutHeight < 1650) {
            suggestedHeight = 0;
          } else if (
            this.$store.state.cutOutHeight >= 1650 &&
            this.$store.state.cutOutHeight < 1850
          ) {
            suggestedHeight = 1646;
          } else if (
            this.$store.state.cutOutHeight >= 1850 &&
            this.$store.state.cutOutHeight < 2046
          ) {
            suggestedHeight = 1846;
          } else if (
            this.$store.state.cutOutHeight >= 2046&
            (this.$store.state.cutOutHeight < 2053)
          ) {
            suggestedHeight = 2046;
          } else if (
            this.$store.state.cutOutHeight >= 2053
          ) {
            suggestedHeight = 2053;
          }
        }
      } else if (route == "/manual") {
        if (this.$store.state.coldroomSystem == "classic") {
          if (this.$store.state.cutOutHeight < 1644) {
            suggestedHeight = 0;
          } else if (
            (this.$store.state.cutOutHeight >= 1644) &
            (this.$store.state.cutOutHeight <= 1844)
          ) {
            suggestedHeight = 1644;
          } else if (
            (this.$store.state.cutOutHeight > 1844) &
            (this.$store.state.cutOutHeight <= 1944)
          ) {
            suggestedHeight = 1844;
          } else if (
            (this.$store.state.cutOutHeight > 1944) &
            (this.$store.state.cutOutHeight <= 2071)
          ) {
            suggestedHeight = 1944;
          } else if (this.$store.state.cutOutHeight > 2071) {
            suggestedHeight = 2071;
          }
        } else {
          if (this.$store.state.cutOutHeight < 1646) {
            suggestedHeight = 0;
          } else if (
            (this.$store.state.cutOutHeight >= 1646) &
            (this.$store.state.cutOutHeight < 1846)
          ) {
            suggestedHeight = 1646;
          } else if (
            (this.$store.state.cutOutHeight >= 1846) &
            (this.$store.state.cutOutHeight < 2046)
          ) {
            suggestedHeight = 1846;
          } else if (
            this.$store.state.cutOutHeight >= 2046&
            (this.$store.state.cutOutHeight < 2053)
          ) {
            suggestedHeight = 2046;
          } else if (
            this.$store.state.cutOutHeight >= 2053
          ) {
            suggestedHeight = 2053;
          }
        }
      }
      this.$store.commit("setSuggestedHeight", suggestedHeight);
    },
  }
};
</script>
